 <template>
    <div v-bind:style='backgroundImage' class='signup-main'>
      <div :class="[textColor, 'fs-5', 'pe-2', 'ps-2', 'text-outline', 'mt-1']">
        <div class='d-flex flex-column text-center header-text'>Terms & Conditions</div>
        <div class='d-flex flex-column terms-conditions-container'>
          <div class='col-12'>
            <div class='mt-2'>Mega Match Rivals Subscription Service</div>
            <div class='mt-2'>Mega Match Rivals is a subscription service (Hereinafter referred to as the "Service") charged at R 7.00 per day (network charges may also apply and free minutes/bundles do not apply).</div>
            <div class='mt-2'>
              These terms and conditions (Hereinafter referred to as these “T’s and C’s”) govern the relationship between the user of the Service (Hereinafter referred to as “You” and/or “Your”), and the promotor of the Service, being Fanclash (Pty) Ltd (Hereinafter referred to as “We” or “Us” and/or the “Service Promotor”) and our duly appointed payment facilitation partner Wordlplay (Pty) Ltd (Hereinafter referred to as “Worldplay”).
            </div>
            <div class='mt-2'>
              These T’s and C’s, as may be amended by Us from time to time may be viewed at wp.megamatchrival.com/terms-and-conditions
            </div>
            <div class='mt-2'>
              Note:
            </div>
            <div class='mt-2'>
              A. These “T’s and C’s”) contain assumptions of risk and/or liability by You, and limit and exclude liabilities, obligations and legal responsibilities which Your Mobile Network Operator has towards You and other persons.
            </div>
            <div class='mt-2'>
              B. These T’s and C’s may also limit and/or exclude Your rights and remedies against Your Mobile Network Operator, and/or place various risks, liabilities, obligations and legal responsibilities on You.
            </div>
            <div class='mt-2'>
              C. These T’s and C’s may result in You being responsible for paying additional costs and amounts and Your Mobile Network Operator may also have claims and other rights against You.
            </div>
            <div class='mt-2'>
              D. To the extent that these T’s and C’s or any goods or services provided under these T’s and C’s are governed by the Consumer Protection Act, 2008 (Hereinafter referred to as the “CPA”), no provision of these T’s and C’s is intended to contravene the applicable provisions of the CPA, and therefore all provisions of these T’s and C’s must be treated as being qualified, to the extent necessary, to ensure that the applicable provisions of the CPA are complied with.
            </div>
            <div class='mt-2'>
              E. You must read these T’s and C’s carefully and make sure that You do not make use of any services and/or goods unless You agree fully herewith. The use of this product/service will constitute as agreement to comply with these T’s and C’s.
            </div>
            <div class='mt-2'>
              By making use of the Service, You expressly agree that;
            </div>
            <div class='mt-2'>
              1. You are 18 years of age or older.
            </div>
            <div class='mt-2'>
              2. You have the bill payers express and informed consent to subscribe to the Service, and agree that in addition to binding Yourself to these T’s and C’s, You are further authorised to bind the bill payer to these T’s and C’s, which you do by subscribing to, and/or otherwise making use of, the Service.
            </div>
            <div class='mt-2'>
              3. Notwithstanding the identity of the Service Promotor, You acknowledge that Your account will be billed directly by the Service Promotor’s payment facilitation partner Worldplay who is acting purely as a payment facilitation conduit between Your Mobile Network Operator and the Service Promotor. Worldplay do not have any involvement in the Service itself beyond facilitating payment between the Service Promotor and Your Mobile Network Operator.
            </div>
            <div class='mt-2'>
              4. Network fees may be applicable on top of the subscription cost of the Service and it is Your sole responsibility to ensure you are aware thereof. We recommend that You contact Your Mobile Network Operator in the event that you are uncertain.
            </div>
            <div class='mt-2'>
              5. Aside from possible network fees, as referenced in point 4 above, the cost of the Service as advertised includes all other costs and is inclusive of Value-Added Tax.
            </div>
            <div class='mt-2'>
              6. Free minutes and/or SMS bundles do not apply.
            </div>
            <div class='mt-2'>
              IMPORTANT PROVISION: ACCEPTANCE OF THESE TERMS AND CONDITIONS
            </div>
            <div class='mt-2'>
              PLEASE READ THESE T’s AND C’s CAREFULLY BEFORE USING THE SERVICE OR SUBMITTING INFORMATION THROUGH THE SERVICE. BY USING THE SERVICE OR SUBMITTING INFORMATION THROUGH THE SERVICE, YOU ARE AGREEING TO THESE T’s AND C’s. IF YOU DO NOT AGREE, PLEASE DO NOT USE THIS SERVICE OR SUBMIT ANY INFORMATION THROUGH THE SERVICE. WE RESERVE THE RIGHT, AT ANY TIME, TO MODIFY AND UPDATE THESE T’s AND C’s FROM TIME TO TIME BY POSTING SUCH UPDATED TERMS AND CONDITIONS ON THE OUR WEBSITE AT HTTP://WP.MEGAMATCHRIVAL.COM/. ANY SUCH UPDATES SHALL APPLY TO YOU AND YOUR USE OF THE SERVICE AND BY CONTINUING TO USE THE SERVICE, YOU SHALL BE DEEMED TO HAVE ACCEPTED SUCH CHANGES.
            </div>
            <div class='mt-2'>
              IF YOU DO NOT HAVE THE BILL PAYERS’ PERMISSION TO SUBSCRIBE TO, AND/OR OTHERWISE USE, THE SERVICE - THEN DO NOT ACCESS THE SERVICE AND CEASE USING THE SERVICE IMMEDIATELY.
            </div>
            <div class='mt-2'>
              1. INTRODUCTION
            </div>
            <div class='mt-2'>
              1.1 The Service is a head-to-head match-3 puzzle game. The Service allows customers to compete against each other by taking alternating turns to score points on the same game board. The player with the most points at the end of 8 turns (15 seconds each) wins.
            </div>
            <div class='mt-2'>
              1.2 The Service is a subscription-based service charge at R5.00/day.
            </div>
            <div class='mt-2'>
              1.3 Pricing may vary depending on promotion activity or adjustments by Your Mobile Network Operator and/or the Service Promotor.
            </div>
            <div class='mt-2'>
              1.4 Micro-Billing: If full billing fails due to insufficient airtime, Your Mobile Network Operator may attempt partial billing (micro-billing). If no billing succeeds within 30 (Thirty) days, Your subscription may be cancelled
            </div>
            <div class='mt-2'>
              1.5 By subscribing to the Service, You agree to the following additional rules upon successful initial registration for the Service:
            </div>
            <div class='mt-2'>
              1.5.1 You will be eligible to access all the content on the Service from the time of successful subscription to the Service.
            </div>
            <div class='mt-2'>
              1.5.2 You will be charged a subscription fee of R5.00 (Five Rand) per day, (incl. VAT) (the “Fee”) for the relevant period that You remain subscribed for the Service.
            </div>
            <div class='mt-2'>
              2. DURATION
            </div>
            <div class='mt-2'>
              2.1 This offering is available from the 25th of July 2025 until such time as Your Mobile Network Operator elects to terminate it in its sole discretion.
            </div>
            <div class='mt-2'>
              2.2 Notwithstanding the above, Your Mobile Network Operator may amend the duration to a shorter or longer period, or withdraw it entirely, with notice to You.
            </div>
            <div class='mt-2'>
              2.3 Visit http://wp.megamatchrival.com/ for notices, updates, and/or changes.
            </div>
            <div class='mt-2'>
              3. WHO IS ELIGIBLE?
            </div>
            <div class='mt-2'>
              3.1 To participate, You must:<br>
              3.1.1 Be a South African citizen;<br>
              3.1.2 Reside in South Africa;<br>
              3.1.3 Be a natural person;<br>
              3.1.4 Be 18 (Eighteen) years or older;<br>
              3.1.5 Subscribe to the Service via USSD, mobile site, or other channels made available by Your Mobile Network Operator.
            </div>
            <div class='mt-2'>
              4. HOW THE SERVICE WORKS
            </div>
            <div class='mt-2'>
              4.1 You must subscribe and create a profile using Your MSISDN and OTP.
            </div>
            <div class='mt-2'>
              4.2 Profiles track matches entered, points earned and MMR points balance
            </div>
            <div class='mt-2'>
              4.3 Each day, users are awarded 50 coins upon login (users must collect them manually).
            </div>
            <div class='mt-2'>
              4.4 Each game costs 10 coins to play.
            </div>
            <div class='mt-2'>
              4.5 Players take alternating turns (8 turns of 15 seconds each).
            </div>
            <div class='mt-2'>
              4.6 Users compete on the same board with visible moves.
            </div>
            <div class='mt-2'>
              4.7 Users must score more points than their opponent to win.
            </div>
            <div class='mt-2'>
              4.8 If a user runs out of coins, they may top up with airtime or wait for the next day’s allocation.
            </div>
            <div class='mt-2'>
              4.9 Power-Ups Include:<br>
              • Bomb (destroy 4 gems)<br>
              • Freeze Time (pause timer)<br>
              • Double Points (x2 points for 3s)<br>
              • Switch (swap any two tiles)<br>
              • Tornado (reshuffle board)<br>
              • Eyes (highlight possible moves)
            </div>
            <div class='mt-2'>
              5. PRIZES AND REWARDS
            </div>
            <div class='mt-2'>
              5.1 Prizes and rewards are determined by competition type, tournament rules, and available BLG coins.
            </div>
            <div class='mt-2'>
              5.2 Not all gameplay guarantees a win.
            </div>
            <div class='mt-2'>
              5.3 Users enter daily draws by holding coins at 12:00 noon reset.
            </div>
            <div class='mt-2'>
              5.4 More coins = more entries.
            </div>
            <div class='mt-2'>
              5.5 Winners selected from top users based on coin balances.
            </div>
            <div class='mt-2'>
              5.6 Prizes are not guaranteed, and are not transferrable or redeemable for cash.
            </div>
            <div class='mt-2'>
              5.7 Prizes are deposited into Your Mobile Network Operator wallets.
            </div>
            <div class='mt-2'>
              5.8 Your Mobile Network Operator and the Service Promotor reserve the right to adjust prize pools, points allocations, and gameplay mechanics.
            </div>
            <div class='mt-2'>
              5.9 Your Mobile Network Operator and the Service Promotor are not liable for network issues, failure to redeem, or loss of prizes post-delivery.
            </div>
            <div class='mt-2'>
              6. MESSAGING AND NOTIFICATIONS
            </div>
            <div class='mt-2'>
              6.1 By subscribing, You consent to receive:<br>
              6.1.1 Gameplay updates;<br>
              6.1.2 Leaderboard stats;<br>
              6.1.3 Promotional offers and service notifications, including marketing messages from the Service Promotor and/or Worldplay.<br>
              6.1.4 To opt-out of marketing SMS “STOP” to 31009 or update settings in Your user profile.<br>
              6.1.5 System alerts essential to Service operation will continue.<br>
              6.1.6 YOU FURTHER EXPRESSLY CONSENT TO RECEIVING MARKETING MESSAGES FROM TIME TO TIME FROM US AND/OR FROM WORLDPLAY, WHICH CONSENT MAY BE REVOKED AT ANY TIME BY FOLLOWING THE OPT-OUT INSTRUCTIONS CONTAINED IN THE RELEVANT MARKETING MESSAGE.
            </div>
            <div class='mt-2'>
              7. UNSUBSCRIBING
            </div>
            <div class='mt-2'>
              7.1 To unsubscribe:<br>
              7.1.1 SMS “STOP” to 31009, or;<br>
              7.1.2 Visit the MMR website (http://wp.megamatchrival.com/) or Your Mobile Network Operators’ self-service platform.
            </div>
            <div class='mt-2'>
              7.2 Your profile may be retained for regulatory, support or promotional reasons for 6 (Six) months, or up to 5 (Five) years if required by law.
            </div>
            <div class='mt-2'>
              8. RICA COMPLIANCE
            </div>
            <div class='mt-2'>
              8.1 In terms of the Amended Regulation of Interception of Communications and Provision of Communication-related Information Act 70 of 2002 (Hereinafter referred to as “RICA”), customers are obliged to register their SIM cards with full personal information.
            </div>
            <div class='mt-2'>
              8.2 Failure to comply will result in deactivation of the SIM, impacting access to the Service.
            </div>
            <div class='mt-2'>
              8.3 If a SIM card is lost, stolen, or damaged, it must be reported to SAPS and Your Mobile Network Operator immediately.
            </div>
            <div class='mt-2'>
              8.4 Offers and subscriptions are non-transferable upon change of SIM ownership
            </div>
            <div class='mt-2'>
              9. MODIFICATION OF TERMS AND CONDITIONS
            </div>
            <div class='mt-2'>
              9.1 Your Mobile Network Operator and/or the Service Promotor reserves the right at any time to change, vary, amend, or replace these T’s and C’s, or any rules related to the Service.
            </div>
            <div class='mt-2'>
              9.2 See wp.megamatchrival.com/terms-and-conditions for updated T’s and C’s.
            </div>
            <div class='mt-2'>
              9.3 Continued use of the Service after changes will be deemed acceptance.
            </div>
            <div class='mt-2'>
              9.4 Your Mobile Network Operator and/or the Service Promotor also reserves the right to vary Service charges at their discretion.
            </div>
            <div class='mt-2'>
              10. LIMITATION OF LIABILITY
            </div>
            <div class='mt-2'>
              10.1 You agree that Your use of the Service shall be at Your sole risk. To the fullest extent permitted in law, We, Your Mobile Network Operator and/or Worldplay, and our officers, directors, employees, and agents disclaim all warranties, express or implied, in connection with the Service and Your use thereof. We make no warranties or representations about the accuracy, completeness and/or ongoing availability of the Service and/or the Service’s content, or the content of any websites or services linked to these services and assume no liability or responsibility for any (i) errors, mistakes, or inaccuracies of content; (ii) personal injury or property damage of any nature whatsoever resulting from Your access to and use of the Service; (iii) any unauthorized access to or use of our servers and/or any and all personal information and/or financial information stored therein; (iv) any interruption or cessation of transmission to or from the Service; (v) any bugs, viruses, trojan horses or the like which may be transmitted to or through the Service by any third party; or (vi) any errors or omissions in any content or for any loss or damage of any kind incurred as a result of the use of any content posted, emailed, transmitted, or otherwise made available via the Service. We, Your Mobile Network Operator and/or Worldplay do not warrant, endorse, guarantee, or assume responsibility for any product or Service advertised or offered by a third party through the Service or any hyperlinked website or featured in any banner or other advertising, and will not be a party to or in any way be responsible for monitoring any transaction between You and third-party providers of products or services.
            </div>
            <div class='mt-2'>
              10.2 To the extent permitted by applicable law, in no event shall We, Your Mobile Network Operator and/or Worldplay, and/or our respective subsidiaries and affiliates, and their respective officers, directors, owners, agents, employees, representatives and licensors be liable for any special, incidental, indirect, consequential, punitive or exemplary losses or damages whatsoever or for loss of profits (including, without limitation, damages for loss of revenue, loss of data, failure to realize expected savings, interruption of activities, or any other pecuniary or economic loss) and whether arising from breach of contract, damages (including negligence), strict liability or otherwise, arising out of the use of or inability to use the Service or its content, or any product or service described or provided through the Service.
            </div>
            <div class='mt-2'>
              10.3 Save to the extent permitted by law, You agree to indemnify, defend and hold harmless Us, Your Mobile Network Operator and/or Worldplay from and against any and all claims, demands, actions, liability, losses, costs and expenses (including legal fees and expenses) arising from or related to: (i) any use or alleged use of the Service by any other person, whether or not authorized by You; (ii) Your breach of these T’s and C’s, including any breach of Your representations and warranties herein; and (iii) Your violation of any law or (iv) Your use of or inability to use the Service, the contents, any hyperlinked website, and any of the products and services made available on the Service thereof.
            </div>
            <div class='mt-2'>
              11. GENERAL
            </div>
            <div class='mt-2'>
              11.1 Leaderboards will be updated on the Service platform and can be accessed via the MMR portal or USSD code (as advised by Your Mobile Network Operator).
            </div>
            <div class='mt-2'>
              11.2 Your Mobile Network Operator and/or the Service Promotor, and/or Worldplay reserves the right to terminate subscriptions in cases of fraud or suspected fraud.
            </div>
            <div class='mt-2'>
              11.3 In addition to these T’s and C’s, You also agree to be bound by any rules pertaining to the specific promotional competition in question (“Promotional Competition T’s and C’s”), as determined by Us from time to time.
            </div>
            <div class='mt-2'>
              11.4 In the event of a conflict between these T’s and C’s and the Promotional Competition T’s and C’s when determining an issue pertaining specifically to a promotional competition, the Promotional Competition T’s and C’s shall apply to the minimum extent necessary to resolve the conflict.
            </div>
            <div class='mt-2'>
              11.5 You acknowledge that any subscriptions in error will be billed. For Your protection, we ask You to confirm all purchases twice.
            </div>
            <div class='mt-2'>
              11.6 You accept that the Service’s default language is English
            </div>
            <div class='mt-2'>
              12. PRIVACY AND SERVICE PROMTOR DATA NOTICE
            </div>
            <div class='mt-2'>
              12.1 What we collect: <br>• Your cell phone number and gameplay activity (logins, match participation, scores).
            </div>
            <div class='mt-2'>
              12.2 How we use it: <br>• To administer tournaments, send confirmations, update leaderboards, allocate BLG coins, and issue marketing SMS (with opt-out).
            </div>
            <div class='mt-2'>
              12.3 Sharing: <br>• Shared only with Your Mobile Network Operator and operational providers (data storage, auditing) to manage Your subscription.
            </div>
            <div class='mt-2'>
              12.4 Retention: <br>• We keep Your data as long as Your profile is active and up to 6 (Six) months post-cancellation for regulatory or promotional communication, or for up to 5 (Five) years where required by applicable laws.
            </div>
            <div class='mt-2'>
              12.5 Security: <br>• The Service Promotor uses reasonable measures to protect data.
            </div>
            <div class='mt-2'>
              12.6 Your rights: <br>• Email support@worldplay.co.za to: <br>  o Opt out of marketing. <br>  o Object to processing or lodge a complaint. <br>• We may take up to 10 working days
            </div>
            <div class='mt-2'>
              13. GOVERNING LAW
            </div>
            <div class='mt-2'>
              This Service and these T’s and C’s are governed by South African law.
            </div>
            <div class='mt-2'>
              14. CONTACT
            </div>
            <div class='mt-2'>
              For further information, please visit email support@worldplay.co.za or call the Worldplay Customer Care line on 086 113 1009.
            </div>
            <div class='mt-2'>
              15. COMPLAINTS
            </div>
            <div class='mt-2'>
              Fanclash (Pty) Ltd, being the Service Promotor is a member of the Wireless Application Service Providers’ Association (“WASPA”) and are bound by the WASPA Code of Conduct, available at www.waspa.org.za. Should You have any concerns or complaints, you may lodge them with WASPA by following their complaints procedure on their website www.waspa.org.za. To assist in resolving complaints, the Service Promotor may need to share information about You and the Service in question with WASPA.
            </div>
          </div>
        </div>
      </div>
      <SpinnerUi v-if='showSpinner' />
    </div>
  </template>

 <script>
  import SpinnerUi from '../SpinnerUi';
  import { dynamicBg } from '../../constants/imageUrlPath';

  export default {
    name: 'SignUpScreenUi',
    components: {
      SpinnerUi,
    },
    data() {
      return {
        showSpinner: false,
        textColor: 'text-black',
      };
    },
    methods: {},
    computed: {
      backgroundImage() {
        return {
          '--background-image': `url(${dynamicBg[0]})`,
        };
      },
    },
    mounted() {
      if (this.$DYNAMIC_BG == 'nigeria1' || this.$DYNAMIC_BG == 'nigeria3')
        this.textColor = 'text-white';
    },
  };
</script>

<style lang='css'>
  @import './index.css';

  .header-text {
    font-size: 30px;
  }

  .terms-conditions-container {
    font-size: 15px;
    height: 80vh;
    overflow: auto;
  }
</style>
